import * as React from 'react';
import { connect } from 'react-redux';
import { IComment, IPagination } from '../../interfaces';
import { NavLink } from 'react-router-dom';
import Axios, { AxiosResponse } from 'axios';
import config from '../../config';
import { toast } from 'react-toastify';
import { withTranslation, WithTranslation } from 'react-i18next';
import {showModal} from '../../actions/modal';

interface IProps extends WithTranslation{
    media_id: number,
    auth: any,
    t: any,
    showModal: any
}

interface IState {
    comments: IComment[],
    isLoading: boolean,
    content: string,
    sending: boolean,
    currentPage: number,
    totalPages: number,
    pages: IPagination,

}

class Comments extends React.Component<IProps, IState>{
    private _isUnmounted: boolean = false;

    constructor(props: IProps) {
        super(props);

        this.state = {
            comments: [],
            isLoading: true,
            content: "",
            sending: false,
            currentPage: 1,
            totalPages: 1,
            pages: null,

        };

        this.onPageChange = this.onPageChange.bind(this);
    }

    componentDidMount (){
        this.loadComments();
    }

    componentWillReceiveProps (prevProps: any){
        this.componentDidMount();
    }

    componentWillUnmount() {
        this._isUnmounted = true;
    }

    
    onPageChange(page: number) {
        this.setState({
            currentPage: page,
            // films: []
        }, async () => {
            await this.loadComments();
        });
    }

    async loadComments() {
        try {
            let response:AxiosResponse = await Axios.get(`${config.host}/auth/comments?media_id=${this.props.media_id}` + (this.state.pages ? `&${this.state.pages.pageParam}=${this.state.currentPage}` : ``));

            let {data} = response;

            if (!this._isUnmounted) {
                this.setState({
                    comments: data.comments,
                    isLoading: false
                })
            }
        } catch (err){

        }
    }

    onContentChange (content: string) {
        this.setState ({
            content
        });
    }

    async voteHandler (type: number, comment_id: number) { // 1 -> like, 2 -> dislike
        if (!this.props.auth.isAuthentificated) {
            this.props.showModal(this.props.t("Голосование разрешено только авторизованным пользователям."));
        } else {
            try {
                let response: AxiosResponse = await Axios.post(`${config.host}/auth/comment-vote`, {
                    comment_id,
                    type
                });
    
                if (response.data.status == "success"){
                    this.setState({
                        comments: this.state.comments.map ((comment: IComment) => {
                            if (comment.id == comment_id) {
                                return {
                                    ...comment,
                                    likes: response.data.likes
                                }
                            }
    
                            return {
                                ...comment
                            };
                        })
                    });
                } else {
                    toast(response.data.message);
                }
               
            } catch (err) {
    
            }
        }
        
    }

    async submitHandler (){
        if (this.state.content != ""){
            this.setState({
                sending: true
            }, async () => {
                let response:AxiosResponse = await Axios.post(`${config.host}/auth/publish`, {
                    media_id: this.props.media_id,
                    content: this.state.content
                });
    
                let {data} = response;
    
                if (data.status == "success") {
                    this.setState({
                        comments: [...this.state.comments, data.comment],
                        content: "",
                        sending: false
                    });
                    toast(this.props.t("Ваш коммент отправлен на модерацию."));
                } else {
                    this.setState({
                        sending: false
                    });
                    
                }
            })
            
        }
    }
    
    replyHandler (full:string) {
        if (this.state.content.indexOf(`@${full}`) == -1) {
            this.setState({
                content: `@${full}, ` + this.state.content
            });
            $("#content").trigger("click").focus();
        }
    }

    render() {
        const {t} = this.props;

        return (
            <div className="box2 box  box3" style={{ paddingBottom: "40px" }}>
                <div className="comments">
                    {!this.props.auth.isAuthentificated && <p className="fs-16 text-danger mb-15">
                        {t("Только зарегистрированные пользователи могут оставлять комментарии.")} <span> </span>
                        <NavLink to="/login">{t("Авторизуйтесь.")}</NavLink>
                    </p>}
                    <h5>{t("Все комментарии")} ({this.state.comments.length})</h5>
                    {this.props.auth.isAuthentificated && <div className="comments-main-form">
                        <div className="comment-form  clearfix">
                            <form id="comment-form" onSubmit={(event: any) => {
                                event.preventDefault();
                                this.submitHandler();
                            }}>
                                <div className="avatar">
                                    <img src={this.props.auth.user.image ? this.props.auth.user.image : (this.props.auth.user.gender == 0 ? "/images/man.jpg" : "/images/woman.jpg")} />
                                </div>
                                <div className="comment-fields display-avatar">
                                    <div className="row">
                                        <div className="col-lg-12">
                                            <div className="form-group field-comment-content required">

                                                <textarea id="content" className="form-control input-sm" name="content" placeholder={t("Поделиться своими мыслями...")} required value={this.state.content} onChange={(event: any) => {
                                                    this.onContentChange (event.target.value);
                                                }}></textarea>

                                                <div className="help-block"></div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="comment-fields-more" >
                                        <div className="buttons text-right">
                                            <button type="submit" className="btn btn-primary btn-sm">
                                                {this.state.sending ? (
                                                    <i className="fa fa-spinner fa-2x rotating "></i>
                                                ) : t("Опубликовать")}
                                                </button>
                                        </div>
                                        <div className="fields">
                                            <div className="row">
                                                <div className="col-lg-6">
                                                    {t("Опубликовать как")} <b>{this.props.auth.user.username}</b> </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>}

                    <div>
                        <div className="comments">
                            {this.state.isLoading && <div className="carousel-placeholder"></div>}
                            {!this.state.isLoading && this.state.comments.length == 0 && <div className="empty">{t("Нет комментариев")}</div>}
                            {!this.state.isLoading && this.state.comments.length > 0 && this.state.comments.map((comment: IComment, index: number) => {
                                return (
                                    <div className="comment" key={index}>
                                        <div className="avatar">
                                            <img src={comment.user.fullpath ? comment.user.fullpath : (comment.user.user_profile.gender == 0 ? "/images/man.jpg" : "/images/woman.jpg")} />
                                        </div>
                                        <div className="comment-content display-avatar">
                                            <div className="comment-header">
                                                <a className="author">{comment.user.user_profile.first + " " + comment.user.user_profile.last}</a>
                                                <span> </span> 
                                                {this.props.auth.isAuthentificated && <a className="reply-btn" onClick={() => {
                                                    this.replyHandler (comment.user.user_profile.first + " " + comment.user.user_profile.last);
                                                }}>
                                                    <i className="fa fa-commenting-o"></i>
                                                    <span> </span>
                                                    {t("Ответить")}
                                                </a>}
                                                <span className="time dot-left dot-right">
                                                    <span> </span> 
                                                    <time>{comment.date}</time>
                                                </span>
                                            </div>
                                            <div className="comment-text-box">
                                                <div className="comment-text">
                                                    {comment.content}
                                                </div>
                                                <div className="comment-rate">
                                                    <div className="comment-plus" onClick={() => {
                                                        this.voteHandler (2, comment.id);
                                                    }}>
                                                        <i className="fa fa-minus"></i>
                                                    </div>
                                                    <span className={comment.likes < 0 ?    "down" : "up" }>{comment.likes}</span>
                                                    <div className="comment-minus" onClick={() => {
                                                        this.voteHandler (1, comment.id);
                                                    }}>
                                                        <i className="fa fa-plus"></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state: any) {
    return {
        auth: state.auth
    };
}

export default connect(mapStateToProps, {showModal})(withTranslation()(Comments));